"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var EventIds;
(function (EventIds) {
  EventIds["FieldCompleted"] = "2ca692cb-bdb2-4c9d-a3b5-917b3656c46a";
  EventIds["FieldError"] = "ea27aca5-432f-424a-b000-26ba5f8ae60a";
})(EventIds || (EventIds = {}));
function createFetchBasedTrackerFetcher(options) {
  return function (formData, endpoint) {
    return fetch(endpoint, __assign({
      body: JSON.stringify(formData),
      method: 'post',
      // IMPORTANT: Sitecore forms relies on cookies for some state management, so credentials must be included.
      credentials: 'include'
    }, options));
  };
}
exports.createFetchBasedTrackerFetcher = createFetchBasedTrackerFetcher;
var FormTracker = /** @class */function () {
  function FormTracker(options) {
    this._currentField = null;
    this._fetcher = options.fetcher || createFetchBasedTrackerFetcher();
    this._endpoint = options.endpoint;
  }
  /** Should be called prior to pushing any events, and again whenever new form schema data is received */
  FormTracker.prototype.setFormData = function (formId, formSessionId, enableTracking) {
    this._formId = formId;
    this._formSessionId = formSessionId;
    this._enableTracking = enableTracking;
  };
  FormTracker.prototype.onFocusField = function (field, value) {
    if (!this._enableTracking || !field.model.isTrackingEnabled) {
      this._resetField();
      return;
    }
    this._startTrackingField(field, value);
  };
  FormTracker.prototype.onBlurField = function (field, value, validationErrors) {
    var _this = this;
    var trackableField = field;
    if (!this._enableTracking || !field.model.isTrackingEnabled) {
      this._resetField();
      return;
    }
    var blurredAtTick = new Date().getTime();
    var duration = trackableField.focusedAtTick ? Math.round((blurredAtTick - trackableField.focusedAtTick) / 1000) : 0;
    trackableField.focusedAtTick = undefined;
    var fieldChanged = this._currentField && this._currentField.fieldIdField.value !== trackableField.fieldIdField.value;
    if (fieldChanged) {
      this._startTrackingField(field, value);
      duration = 0;
    }
    if (fieldChanged || this._isValueChanged(value)) {
      if (this._currentField) {
        this._currentField.originalValue = value;
      }
      var clientEvent = this._buildEvent(field, EventIds.FieldCompleted, duration);
      var validationEvents_1 = [];
      if (validationErrors) {
        validationErrors.forEach(function () {
          validationEvents_1.push(_this._buildEvent(field, EventIds.FieldError, duration));
        });
      }
      this._trackEvents(__spreadArrays(validationEvents_1, [clientEvent]));
    }
  };
  FormTracker.prototype._startTrackingField = function (field, value) {
    var trackableField = field;
    trackableField.focusedAtTick = new Date().getTime();
    trackableField.originalValue = value;
    this._currentField = trackableField;
  };
  FormTracker.prototype._resetField = function () {
    this._currentField = null;
  };
  FormTracker.prototype._isValueChanged = function (newValue) {
    if (!this._currentField || typeof this._currentField.originalValue === 'undefined') {
      return true;
    }
    var originalValue = this._currentField.originalValue;
    if (Array.isArray(newValue)) {
      if (!Array.isArray(originalValue)) {
        return true;
      }
      // array compare
      if (originalValue.length !== newValue.length) {
        return true;
      }
      for (var i = 0; i < originalValue.length; i += 1) {
        if (originalValue[i] !== newValue[i]) {
          return true;
        }
      }
      return false;
    }
    // original value is array but value is not so cannot be equal
    if (Array.isArray(originalValue)) {
      return false;
    }
    // string compare
    return newValue !== this._currentField.originalValue;
  };
  FormTracker.prototype._buildEvent = function (field, eventId, duration) {
    if (!this._formId || !this._formSessionId) {
      throw new Error('Event was pushed without form data being set.');
    }
    return {
      formId: this._formId,
      sessionId: this._formSessionId,
      eventId: eventId,
      fieldId: field.fieldIdField.value,
      duration: duration,
      fieldName: field.model.name
    };
  };
  FormTracker.prototype._trackEvents = function (events) {
    return this._fetcher(events, this._endpoint);
  };
  return FormTracker;
}();
exports.FormTracker = FormTracker;